<template>
  <div v-if="hasAdminPrivileges" class="admin-page__content">
    <div class="d-flex align-items-center justify-content-between">
      <div>
        <h2 class="mb-0">
          {{ $t("logOperaci") }}
        </h2>
      </div>
    </div>
    <div class="mt-4">
      <custom-table-ajax
        v-if="endpoint"
        class="logs mobile-scrollable"
        :full-width="true"
        :endpoint="endpoint"
        :items="audits"
        :columns="[
          {
            name: 'timestamp',
            class: 'timestamp',
            sortable: true,
            filter: 'dateTime',
            separator: '<br />'
          },
          {
            name: 'DESCRIPTION',
            sortable: true,
            filter: 'replaceVariables',
            class: 'description'
          },
          { name: 'level', sortable: true },
          { name: 'projectId', sortable: true },
          { name: 'customerId', sortable: true },
          { name: 'originator', sortable: true }
        ]"
      />
    </div>
  </div>
  <div v-else>
    {{ $t("nemateOpravneniProhlizetTutoStranku") }}
  </div>
</template>

<script>
import customTableAjax from "@/components/custom-table/table-ajax.vue";
import { useAdminStore } from "@/store/modules/admin"
import { useAuthStore } from "@/store/modules/auth"

export default {
  components: {
    "custom-table-ajax": customTableAjax
  },
  props: {
    admin: Object
  },
  setup() {
    const adminStore = useAdminStore()
    const authStore = useAuthStore()
    return { adminStore, authStore }
  },
  data() {
    return {
      endpoint: false,
      audits: [],
      dataLoaded: false
    };
  },
  computed: {
    hasAdminPrivileges() {
      return this.authStore.apiUser?.isIotAdmin === true
    },
    storedReseller() {
      return this.adminStore.reseller
    }
  },
  watch: {
    storedReseller() {
      if (!this.endpoint) this.endpoint = process.env.VUE_APP_API + "/audits";
    }
  },
  mounted() {
    this.endpoint = process.env.VUE_APP_API + "/audits";
  },
  methods: {}
};
</script>

<style lang="scss" scoped></style>
